{
	"greeting": "Привет, {name}",
	"greetingFirstTime": "Привет, {name}. Начнём с первого материала?",
	"firstSteps": {
		"title": "Первые шаги",
		"progress": "{done} из {total}",
		"material": "Добавить первый материал",
		"course": "Собрать курс",
		"topic": "Пройти первую тему до конца",
		"tutor": "Задать вопрос репетитору",
		"rhythm": "Настроить ритм занятий",
		"dismiss": "Скрыть",
		"collapse": "Свернуть",
		"close": "Закрыть",
		"reopen": "Ближайшие шаги"
	},
	"summary": "Сегодня на повторении {dueCards, plural, one {# карточка} few {# карточки} other {# карточек}}.",
	"kpi": {
		"streak": {
			"label": "серия повторений",
			"unit": "дн.",
			"start": "старт"
		},
		"cards": {
			"label": "карточек к повторению",
			"queueReady": "Очередь готова",
			"queueReadyHint": "открой колоду ниже",
			"queueEmptyHint": "новых повторений нет"
		},
		"mastery": {
			"label": "освоение за неделю",
			"trend": "неделя"
		},
		"today": {
			"label": "учёбы сегодня",
			"unit": "мин"
		}
	},
	"deck": {
		"title": "Что повторить сегодня",
		"inQueueShort": "в очереди",
		"refresh": "Обновить",
		"refreshing": {
			"title": "Обновляю рекомендации",
			"subtitle": "Подбираю, что повторить сегодня"
		},
		"next": "Следующая",
		"hide": "Скрыть",
		"position": "Карта {current} из {total}",
		"positionEmpty": "очередь пуста",
		"emptyTitle": "Колода пройдена",
		"emptyBody": "Очередь повторений пуста — отличная работа.",
		"emptyAfterSession": "{done} из {total} отмечено пройденными.",
		"emptyGenerate": "Сгенерировать новые рекомендации",
		"minutes": "{count} мин",
		"kinds": {
			"cards": "Карточки",
			"quiz": "Тест",
			"weakSpot": "Слабые места",
			"note": "Конспект",
			"plan": "Учебный план",
			"exam": "Экзамен",
			"streak": "Серия",
			"material": "Материал",
			"review": "Повторение"
		},
		"actions": {
			"skip": "Отложить",
			"repeat": "Повторить",
			"done": "Готово",
			"dismiss": "Убрать рекомендацию",
			"skipTooltip": "Карта уйдёт в конец колоды",
			"doneTooltip": "Отметить пройденным"
		},
		"hint": "Свайп вправо — готово · влево — отложить · клик по карте — открыть повторение",
		"postponedChip": "Отложена",
		"swipeStamp": {
			"done": "Готово",
			"skip": "Отложить"
		},
		"toast": {
			"done": "Готово — карта закрыта на сегодня",
			"skip": "Отложено — карта вернётся в конце колоды",
			"dismiss": "Рекомендация убрана",
			"open": "Открываю повторение…",
			"markActedFailed": "Не удалось отметить пройденным — попробуй ещё раз",
			"dismissFailed": "Не удалось убрать — попробуй ещё раз",
			"postponeFailed": "Не удалось сохранить «отложено» — попробуй ещё раз"
		}
	},
	"continue": {
		"title": "Продолжить",
		"viewAll": "Все материалы",
		"openedRecently": "Недавно открыто",
		"inCourse": "В курсе: {course}"
	},
	"empty": {
		"title": "Начните с курса — или со своего материала",
		"body": "Курс соберём по теме, возьмём готовый из каталога или сложим из ваших файлов. Отдельный материал StudyHub разберёт на ключевые идеи, карточки и тест.",
		"course": "Мои курсы",
		"upload": "Материалы",
		"record": "Запись лекции",
		"templates": "Каталог курсов"
	},
	"weekGoal": {
		"title": "Цель недели",
		"caption": "{done} из {target} мин",
		"sub": "к цели",
		"subEmpty": "пока пусто"
	},
	"queue": {
		"title": "В очереди",
		"stat": "{count} {count, plural, one {задача} few {задачи} other {задач}} · ~{minutes} мин",
		"hint": "Убери их из очереди. Начни с верхней карты колоды.",
		"hintEmpty": "Очередь пуста — загляни сюда после новых материалов."
	},
	"activity": {
		"title": "Твой ритм",
		"less": "меньше",
		"more": "больше",
		"noActivity": "нет активности",
		"cellSummary": "{minutes} мин"
	},
	"launcher": {
		"title": "Инструменты",
		"tutorChat": "Чат с репетитором",
		"tutorChatHint": "Спроси по своему материалу",
		"recordLecture": "Запись лекции",
		"recordLectureHint": "Лекция станет конспектом",
		"voiceTutor": "Голосовой репетитор",
		"voiceTutorHint": "Разбери тему голосом",
		"audioRecap": "Аудио-резюме",
		"audioRecapHint": "Слушай вместо чтения",
		"essay": "Оценка эссе",
		"essayHint": "Проверка с правками",
		"visuals": "Объяснить по фото",
		"visualsHint": "График, задача, формула",
		"glossary": "Глоссарий",
		"glossaryHint": "Термины из материалов",
		"upload": "Загрузить материал",
		"uploadHint": "PDF, лекция, конспект",
		"characters": "Обучение с персонажем",
		"charactersHint": "Практика с исторической личностью",
		"discover": "Поиск в интернете",
		"discoverHint": "Поиск источников и сохранение в библиотеку",
		"quizzes": "Тесты",
		"quizzesHint": "Проверьте свои знания с помощью теста",
		"flashcards": "Карточки",
		"flashcardsHint": "Запоминайте с помощью интервальных повторений"
	},
	"brief": {
		"title": "Совет дня",
		"refresh": "Обновить советы",
		"refreshing": "Подбираю советы",
		"emptyTitle": "Пока пусто",
		"emptyBody": "Советы появятся, когда наберётся активность.",
		"goalOfDay": "Цель на сегодня",
		"termOfDay": "Термин дня",
		"studyTip": "Совет",
		"didYouKnow": "А знал ли ты",
		"milestone": "Достижение",
		"microCheck": "Проверь себя",
		"revealAnswer": "Показать ответ",
		"practice": "Повторить",
		"open": "Открыть",
		"prev": "Назад",
		"next": "Дальше",
		"expand": "Развернуть",
		"collapse": "Свернуть",
		"goalMinutes": "{done} / {goal} мин"
	},
	"myCourses": {
		"title": "Мои курсы",
		"all": "Все курсы",
		"showAll": "Показать все",
		"showLess": "Свернуть"
	},
	"catalogHighlights": {
		"title": "Каталог курсов",
		"allCourses": "Все курсы",
		"scrollPrev": "Предыдущие курсы",
		"scrollNext": "Следующие курсы"
	}
}
